//Need to pass a capability to open the alt products modal down a few layers to Suggested Products, so using Context.
import React from 'react';
import { SalesCreditMiniForm } from '../../views/salesLedger/salesCredit/salesCreditCommon';

export type IReturnOrderModalState = {
  modalOpen: boolean;
  uuid?: string;
  initialValues?: any;
  miniForm?: SalesCreditMiniForm;
};

export type SalesInvoiceContextType = {
  setReturnOrderModalState: React.Dispatch<React.SetStateAction<IReturnOrderModalState>>;
  setExchangeModalState: React.Dispatch<React.SetStateAction<{ modalOpen: boolean; selection: Array<any> }>>;
};

const SalesInvoiceContext = React.createContext({} as SalesInvoiceContextType);
export default SalesInvoiceContext;
